import { render, staticRenderFns } from "./CombatTeamScore.vue?vue&type=template&id=fb3e63aa&scoped=true"
import script from "./CombatTeamScore.vue?vue&type=script&lang=js"
export * from "./CombatTeamScore.vue?vue&type=script&lang=js"
import style0 from "./CombatTeamScore.vue?vue&type=style&index=0&id=fb3e63aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3e63aa",
  null
  
)

export default component.exports